<template>
  <div class="pageContainer">
    <div class="contentContainer grow">
      <template v-if="resultPage === 0"> <!-- Loading page -->
        <div class="whitebox flex-column align-items-center p-10">
          <IllustrationsSpinnerCircle />
          <p class="has-text-size-20 bold mt-3">
            {{ $t("bnpl:limit.result.loading_results") }}
          </p>
        </div>
      </template>
      <template v-if="resultPage === 1"> <!-- Success page -->
        <h1 class="m-0 mt-1">{{ $t("bnpl:limit.result.title") }}</h1>
        <div class="flex-column gap-24">
          <div class="whitebox flex-column gap-12 p-2">
            <div class="flex-row justify-content-space-between">
              <div class="flex-row gap-12">
                <div class="logo">
                  <figure>
                    <img :src="logoCompactUrl" />
                  </figure>
                </div>
                <div class="flex-column">
                  <p class="has-text-size-14 has-text-grey">
                    {{ $t("bnpl:limit.result.your_available_limit") }}
                  </p>
                  <p class="has-text-size-32 bold">
                    {{ $n(limitData.limitValue, "currency") }}
                  </p>
                </div>
              </div>
              <button
                class="btn btnM fit-content hide-on-mobile"
                @click="restartLimitCalc"
              >
                {{ $t("bnpl:limit.result.button.recalculate") }}
              </button>
            </div>
            <p class="has-text-size-12 has-text-light-grey">
              {{ $t("bnpl:limit.result.descrition") }}
            </p>
            <button
              class="btn btnM fit-content hide-on-desktop"
              @click="restartLimitCalc"
            >
              {{ $t("bnpl:limit.result.button.recalculate") }}
            </button>
          </div>
          <div class="flex-row gap-24 flex-column-mobile">
            <IconCard
              type="success"
              :icon="$t('bnpl:limit.result.card.income.icon')"
              :title="$t('bnpl:limit.result.card.income.title')"
              :description="$t('bnpl:limit.result.card.income.description')"
              :amount="lastSyncData.salary"
            />
            <IconCard
              type="warning"
              :icon="$t('bnpl:limit.result.card.loans.icon')"
              :title="$t('bnpl:limit.result.card.loans.title')"
              :description="$t('bnpl:limit.result.card.loans.description')"
              :amount="lastSyncData.loanAmount"
            />
            <!-- <IconCard
              type="success"
              icon="money-bill"
              :title="$t('bnpl:limit.result.card1.icon')"
              :description="$t('bnpl:limit.result.card1.icon')"
              :amount="lastSyncData.salary"
            /> -->
            <!-- <IconCard
              type="warning"
              icon="receipt"
              :title="$t('bnpl:limit.result.card2.title')"
              :description="$t('bnpl:limit.result.card2.description')"
              :amount="lastSyncData.loanAmount"
            /> -->
          </div>
          <div
            class="whitebox flex-row justify-content-space-between align-items-center p-2"
          >
            <div class="flex-column gap-8">
              <p class="has-text-size-14 bold">
                {{ $t("bnpl:limit.result.other_bank_accounts.title") }}
              </p>
              <p class="has-text-size-14">
                {{ $t("bnpl:limit.result.other_bank_accounts.description") }}
              </p>
            </div>
            <a
              class="link has-text-size-14 bold"
              @click="restartLimitCalc"
            >
              {{ $t("bnpl:limit.result.other_bank_accounts.link") }}
            </a>
          </div>
          <div class="flex-row gap-16 gap-4-on-mobile flex-column-mobile">
            <p>{{ $t("bnpl:limit.result.mistake_found") }}</p>
            <a
              class="link"
              @click="openMistakeFoundPopup"
            >
              {{ $t("bnpl:limit.result.mistake_found.link") }}
              <font-awesome-icon
                :icon="['fas', 'right-long']"
                class="has-text-size-12"
              />
            </a>
          </div>
        </div>
      </template>
      <template v-if="resultPage === 2"> <!-- Denied page -->
        <h1 class="m-0 mt-1">{{ $t("bnpl:limit.result.title") }}</h1>
        <div class="flex-column gap-24">
          <div class="whitebox flex-column gap-12 p-2">
            <div class="flex-row justify-content-space-between">
              <div class="flex-row gap-12">
                <div class="error-illustration hide-on-mobile">
                  <IllustrationsError />
                </div>
                <div class="flex-column">
                  <div class="error-illustration align-self-center hide-on-desktop mb-1">
                    <IllustrationsError />
                  </div>
                  <p class="has-text-size-20 bold mb-1">
                    {{ $t("bnpl:limit.result.fail.title") }}
                  </p>
                  <p class="has-text-size-14 has-text-grey">
                    {{ $t("bnpl:limit.result.fail.description") }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="flex-row gap-24 flex-column-mobile">
            <IconCard
              type="success"
              :icon="$t('bnpl:limit.result.card.income.icon')"
              :title="$t('bnpl:limit.result.card.income.title')"
              :description="$t('bnpl:limit.result.card.income.description')"
              :amount="lastSyncData.salary"
            />
            <IconCard
              type="warning"
              :icon="$t('bnpl:limit.result.card.loans.icon')"
              :title="$t('bnpl:limit.result.card.loans.title')"
              :description="$t('bnpl:limit.result.card.loans.description')"
              :amount="lastSyncData.loanAmount"
            />
          </div>
          <div
            class="whitebox flex-row justify-content-space-between align-items-center p-2"
          >
            <div class="flex-column gap-8">
              <p class="has-text-size-14 bold">
                {{ $t("bnpl:limit.result.other_bank_accounts.title") }}
              </p>
              <p class="has-text-size-14">
                {{ $t("bnpl:limit.result.other_bank_accounts.description") }}
              </p>
            </div>
            <a
              class="link has-text-size-14 bold"
              @click="restartLimitCalc"
            >
              {{ $t("bnpl:limit.result.other_bank_accounts.link") }}
            </a>
          </div>
          <div class="flex-row gap-16 gap-4-on-mobile flex-column-mobile">
            <p>{{ $t("bnpl:limit.result.mistake_found") }}</p>
            <a
              class="link"
              @click="openMistakeFoundPopup"
            >
              {{ $t("bnpl:limit.result.mistake_found.link") }}
              <font-awesome-icon
                :icon="['fas', 'right-long']"
                class="has-text-size-12"
              />
            </a>
          </div>
        </div>
      </template>
      <template v-if="resultPage === 3"> <!-- What next page -->
        <h1 class="m-0">{{ $t("bnpl:limit.result.title.what_next") }}</h1>
        <div class="flex-column gap-24 stretch">
          <div class="whitebox flex-column gap-12 p-3">
            <div class="flex-row justify-content-space-between">
              <div class="flex-row gap-12">
                <div class="logo">
                  <figure>
                    <img :src="logoCompactUrl" />
                  </figure>
                </div>
                <div class="flex-column">
                  <p class="has-text-size-14 has-text-grey">
                    {{ $t("bnpl:limit.result.your_available_limit") }}
                  </p>
                  <p class="has-text-size-32 bold">
                    {{ $n(limitData.limitValue, "currency") }}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="whitebox flex-column gap-18 p-3">
            <div>
              <p class="h bold mb-3">
                {{ $t("bnpl:limit.result.flow.title") }}
              </p>
              <div class="next-steps">
                <div class="next-step">
                  <div class="next-step-circle">1</div>
                  <p class="bold">
                    {{ $t("bnpl:limit.result.flow_step_1.title") }}
                  </p>
                  <span>
                    {{ $t("bnpl:limit.result.flow_step_1.description") }}
                  </span>
                </div>
                <div class="next-step">
                  <div class="next-step-circle">2</div>
                  <p class="bold">
                    {{ $t("bnpl:limit.result.flow_step_2.title") }}
                  </p>
                  <span>
                    {{ $t("bnpl:limit.result.flow_step_2.description") }}
                  </span>
                </div>
                <div class="next-step">
                  <div class="next-step-circle">3</div>
                  <p class="bold">
                    {{ $t("bnpl:limit.result.flow_step_3.title") }}
                  </p>
                  <span>
                    {{ $t("bnpl:limit.result.flow_step_3.description") }}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <template v-if="bestSellingProductCount > 0">
            <p class="has-text-align-center has-text-size-20 bold">
              {{ $t("bnpl:limit.result.popular_products.title") }}
            </p>
            <div class="whitebox flex-column gap-18 p-3">
              <ProductCarousel />
            </div>
          </template>
        </div>
      </template>
    </div>
    <div class="actionArea">
      <button
        v-if="resultPage === 3"
        class="linkButton linkButtonSuccess justify-self-start-desktop leftAction"
        @click="previousStep"
      >
        <font-awesome-icon :icon="['fas', 'arrow-left']" />{{
          $t("bnpl:cancel")
        }}
      </button>
      <button
        v-if="resultPage === 3 || resultPage === 2"
        class="btn btnL rightAction"
        @click="backToSelfcare"
      >
        {{ $t("bnpl:continue") }}
      </button>
      <button
        v-else
        class="btn btnL rightAction"
        @click="nextStep"
      >
        {{ $t("bnpl:continue") }}
      </button>
    </div>
  </div>
  <Popup
    v-if="showMistakeFoundPopup"
    @close="closeMistakeFoundPopup"
  >
    <div
      class="flex-column align-items-center gap24"
      style="width: 100%; max-width: 400px"
    >
      <template v-if="mistakeFoundPopupStatus === 'START'">
        <h2 class="h bold">{{ $t("bnpl:psd2.mistake_found") }}</h2>
        <p>
          {{ $t("bnpl:psd2.send_correct_data-text") }}
        </p>
        <div class="flex-column gap12 stretch">
          <div class="inputField">
            <label class="p-caption bold">
              {{ $t("bnpl:income") }}
              <span
                class="bold"
                style="color: var(--systemError)"
                >*</span
              >
            </label>
            <input
              v-model="mistakeFoundForm.overrideSalary"
              class="textInput"
            />
          </div>
          <div class="inputField">
            <label class="p-caption bold">
              {{ $t("bnpl:psd2.sum_of_monthly_payments") }}
              <span
                class="bold"
                style="color: var(--systemError)"
                >*</span
              >
            </label>
            <input
              v-model="mistakeFoundForm.overrideLoans"
              class="textInput"
            />
          </div>
          <div class="inputField">
            <label class="p-caption bold">
              {{ $t("bnpl:psd2.describe_the_problem") }}
              <span
                class="bold"
                style="color: var(--systemError)"
                >*</span
              >
            </label>
            <textarea
              v-model="mistakeFoundForm.message"
              class="textInput"
            />
          </div>
          <button
            class="btn btnL grow"
            @click="sendOverride"
          >
            {{ $t("bnpl:send") }}
          </button>
        </div>
      </template>
      <template v-else-if="mistakeFoundPopupStatus === 'SUCCESS'">
        <IllustrationsSuccess />
        <div class="flex-row justify-content-center stretch">
          <h2
            class="h bold"
            style="color: var(--systemSuccess)"
          >
            {{ $t("bnpl:psd2mistake.success") }}
          </h2>
        </div>
      </template>
      <template v-else-if="mistakeFoundPopupStatus === 'FAIL'">
        <IllustrationsError />
        <div class="flex-row justify-content-center stretch">
          <h2
            class="h bold"
            style="color: var(--systemError)"
          >
            {{ $t("bnpl:psd2mistake.fail") }}
          </h2>
        </div>
      </template>
    </div>
  </Popup>
</template>

<script setup>
import { LIMIT_STATUS, PSD2_TYPE } from "~~/utils/const";
import { useBrandingStore } from "~~/stores/branding";
import { useLimitStore } from "~~/stores/limit";
import { usePsd2SyncStore } from "~~/stores/psd2Sync";
import { useReviewStore } from "~~/stores/review";
import { usePsd2GocaStore } from "~~/stores/psd2GocaStore";
import { useCountryStore } from "~~/stores/country";

const countryStore = useCountryStore();
const brandingStore = useBrandingStore();
const limitStore = useLimitStore();
const reviewStore = useReviewStore();
const psd2SyncStore = usePsd2SyncStore();
const psd2GocaStore = usePsd2GocaStore();

const resultPage = ref(0);

const route = useRoute();

const limitData = computed(() => limitStore.limit);
const lastSyncData = computed(() => {
  if (countryStore.psd2Type === PSD2_TYPE.GO_CARDLESS) {
    return psd2GocaStore.latestSync.lastSyncData;
  }
  return psd2SyncStore.latest.lastSyncData;
});
const logoCompactUrl = computed(() => brandingStore.logoCompactUrl);

const showMistakeFoundPopup = ref(false);
const mistakeFoundForm = reactive({
  overrideSalary: 0,
  overrideLoans: 0,
  message: "",
});
const mistakeFoundPopupStatus = ref("START");
function openMistakeFoundPopup() {
  showMistakeFoundPopup.value = true;
}
function closeMistakeFoundPopup() {
  showMistakeFoundPopup.value = false;
  mistakeFoundPopupStatus.value = "START";
}
async function sendOverride() {
  let request = {
    overrideSalary: mistakeFoundForm.overrideSalary,
    overrideLoans: mistakeFoundForm.overrideLoans,
    message: mistakeFoundForm.message,
  };
  try {
    await psd2SyncStore.mistakeFound(request);
    mistakeFoundPopupStatus.value = "SUCCESS";
  } catch (e) {
    mistakeFoundPopupStatus.value = "FAIL";
  }
}

const bestSellingProductCount = computed(
  () => reviewStore.bestSellingProducts.length
);

onBeforeMount(async () => {
  await limitStore.fetchMyLastLimit();
  if (countryStore.psd2Type === PSD2_TYPE.GO_CARDLESS) {
    await psd2GocaStore.getStatus({ force: false });
  } else {
    await psd2SyncStore.getStatus({ force: false });
  }
  await reviewStore.fetchBestSellingProducts(route.params.financier);
  if (limitStore.limit && limitStore.limit.status === LIMIT_STATUS.ACTIVE) {
    resultPage.value = 1;
  } else {
    resultPage.value = 2;
  }
});

const restartLimitCalc = async () => {
  await limitStore.cancelLimit(limitStore.limit.id);
  await limitStore.createLimit(LIMIT_SOURCE.PROFILE);
};

function nextStep() {
  if (resultPage.value === 1) {
    resultPage.value = 3;
  }
}

function previousStep() {
  if (limitStore.limit && limitStore.limit.status === LIMIT_STATUS.ACTIVE) {
    resultPage.value = 1;
  } else {
    resultPage.value = 2;
  }
}

function backToSelfcare() {
  navigateTo({ name: "financier" });
}
</script>

<style scoped lang="scss">
.logo {
  padding: 11px;
  background: var(--gray50);
  border-radius: 8px;
  figure {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 38px;
    height: 38px;
    margin: 0;
    img {
      display: block;
      max-width: 100%;
      max-height: 100%;
    }
  }
}

.error-illustration {
  width: 95px;
  height: 95px;
  background: var(--gray50);
  border-radius: 8px;
  flex-shrink: 0;
  svg {
    width: 100%;
    height: 100%;
  }
}

.next-steps {
  position: relative;
  display: flex;
  flex-direction: row;
  gap: 14px;

  .next-step {
    display: grid;
    grid-template-areas:
      "circle main"
      "circle span";
    grid-template-columns: min-content auto;
    grid-template-rows: min-content auto;
    align-content: stretch;
    column-gap: 10px;
    row-gap: 4px;
    flex: 1;
    align-items: center;

    .next-step-circle {
      width: 36.8px;
      height: 36.8px;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 2px solid var(--brandPrimary);
      border-radius: 999999px;
      color: var(--brandPrimary);
      font-size: 18px;
      font-weight: bold;
      grid-area: circle;
      background: white;
      z-index: 1;
    }

    p {
      grid-area: main;
      font-size: 12px;
    }

    span {
      grid-area: span;
      font-size: 11px;
      color: var(--gray600);
    }
  }
}

.fit-content {
  min-width: fit-content;
  flex-grow: 0;
}

@media only screen and (max-width: 792px) {
  .contentContainer {
    gap: 24px;
  }

  .gap-4-on-mobile {
    gap: 4px;
  }

  .next-steps {
    flex-direction: column;
    .next-step {
      align-items: start;
    }
  }

  .flex-column-mobile {
    flex-direction: column;
  }
}
</style>
